<template>
    <div>
        <div class="QCBatchDetail" v-if="batch">
            <!--Header-->
            <div class="display-flex align-center role-status">
                <div class="ml-6">{{ $f.tc('youAre', [$f.tc(qcCampaign.permission)]) }}</div>
            </div>
            <div class="display-flex align-center justify-space-between header-page">
                <div class="page-title mr-6">
                    <div class="display-flex align-center">
                        <img src="/img/scenario/back.svg" alt="icon-back" style="transform: scale(1.2)"
                             class="mr-10 icon-back" @click="backToBatchList">
                        <div class="tab-title">
                            {{ batch.name }}
                        </div>
                        <div v-if="batch.status" class="status"
                             :class="[batch.status === 'open' ? 'status-open' : 'status-close']"
                        >
                            {{ batch.status }}
                        </div>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <div class="btn-icon btn-info-chart ml-8">
                                    <v-icon color="#96ADD0" v-bind="attrs" v-on="on">mdi-information</v-icon>
                                </div>
                            </template>
                            <div v-if="customerPropertyCondition.length > 0">
                                <div class="tooltip-header">Customer Property</div>

                                <template v-for="(item, index) in customerPropertyCondition">
                                    <li v-if="['is_between', 'is_not_between'].includes(item.operator)" :key="index">
                                        {{ item.field }} {{ item.operator }} {{ item.from }} - {{ item.to }}
                                    </li>
                                    <li v-if="!(['is_between', 'is_not_between'].includes(item.operator))" :key="index">
                                        {{ item.field }} {{ item.operator }} {{ item.value }}
                                    </li>
                                </template>
                            </div>
                            <div v-if="systemCondition.length > 0">
                                <div class="tooltip-header">System</div>
                                <template v-for="(item, index) in systemCondition">
                                    <li v-if="['is_between', 'is_not_between'].includes(item.operator)" :key="index">
                                        {{ item.field }} {{ item.operator }} {{ item.from }} - {{ item.to }}
                                    </li>
                                    <li v-if="!(['is_between', 'is_not_between'].includes(item.operator))" :key="index">
                                        {{ item.field }} {{ item.operator }} {{ item.value }}
                                    </li>
                                </template>
                            </div>
                            <div v-if="dataCollectionCondition.length > 0">
                                <div class="tooltip-header">Data Collection</div>
                                <template v-for="(item, index) in dataCollectionCondition">
                                    <li v-if="['is_between', 'is_not_between'].includes(item.operator)" :key="index">
                                        {{ item.field }} {{ item.operator }} {{ item.from }} - {{ item.to }}
                                    </li>
                                    <li v-if="!(['is_between', 'is_not_between'].includes(item.operator))" :key="index">
                                        {{ item.field }} {{ item.operator }} {{ item.value }}
                                    </li>
                                </template>
                            </div>
                            <div
                                v-if="customerPropertyCondition.length === 0 &&
                                systemCondition.length === 0 &&
                                dataCollectionCondition.length === 0">
                                <div class="tooltip-header">{{$f.tc('batchHasNoConditions')}}</div>
                            </div>
                        </v-tooltip>

                    </div>
                    <div class="assignee">
                        <div class="mr-8" style="color: #262626">{{ $f.tc('assignee') }}:</div>
                        <div class="display-flex align-center">
                            {{ $utils.limitStringLength(batch['assign_to'].join(", "), 50) }}
                            <div class="btn-edit" @click="openAssigneeEditor"></div>
                        </div>
                    </div>
                </div>
                <div v-if="canEditQCCampaign(permission)" class="display-flex align-center">
                    <div class="btn-primary mr-10" @click="openAddCallEditor">
                        {{ $f.tc('addCallToBatch') }}
                    </div>
                    <div
                        :class="isLoadingExport ? 'btn-primary-disable mr-10' : 'btn-primary mr-10'"
                        @click="exportBatch"
                    >
                        {{ $f.tc('exportReport') }}
                        <v-progress-circular
                            indeterminate
                            width="3"
                            color="grey"
                            class="ml-6"
                            style="width: 16px"
                            v-if="isLoadingExport"
                        ></v-progress-circular>
                    </div>
                    <div
                        :class="[batch.status === 'open' ? 'btn-outline-danger' : 'btn-outline-success']"
                        @click="updateStatusBatch"
                    >
                        {{ $f.tc(batch.status === 'open' ? 'closeBatch' : 'openBatch') }}
                    </div>

                </div>
            </div>
            <!--table list qc campaign-->
            <v-container fluid class="scrollbar-custom call-list">
                <!--list filter or search-->
                <div class="display-flex align-center justify-start mb-10">
                    <div style="width: 380px; position: relative">
                        <v-text-field
                            hide-details
                            v-model="filter.callId"
                            :placeholder="$f.tc('searchCallId')"
                            @keypress.enter="refresh()"
                            class="input-custom"
                        ></v-text-field>
                        <img src="/img/search.svg" alt="icon_search" class="icon-search" @click="refresh()">
                    </div>
                    <div style="width: 200px; margin-left: 10px">
                        <v-select
                            hide-details outlined
                            :placeholder="$f.tc('status')"
                            :items="statusOptions"
                            v-model="filter.status"
                            class="input-custom"
                            clearable
                        ></v-select>
                    </div>
                </div>
                <!--list table-->
                <div>
                    <div class="d-flex scrollbar-custom list-table">
                        <div v-for="(table, index) in callListData"
                             :key="index"
                             :class="'qc-campaign-table qc-campaign-child-' + (index + 1)">
                            <DataTableCustom
                                :table-title="table.title"
                                :headers="table.headers"
                                :items="table.data"
                                :config-column="true"
                                :hide-pager="true"
                                :current-page="pagination.page"
                                :total-page="totalPage"
                                :items-per-page="pagination.rowsPerPage"
                                :total-items="totalItems"
                                :keep-desktop-layout="true"
                                :add-index="index === 0"
                                @row-click="goToStartWork"
                                @sort-change="refresh($event)"
                                :sort-direction="sortDirection"
                                :sort-by="sortBy"
                            >
                                <template v-slot:qc_by="props">
                                    <div class="display-flex align-center">
                                        <div>
                                            {{ props.item.qc_by }}
                                        </div>
                                        <v-btn icon small class="mx-0"
                                               v-if="props.item.status === 'in_progress' && canEditQCCampaign(qcCampaign.permission)"
                                               @click.stop="openReassignEditor(props.item.id, props.item.qc_by)">
                                            <img src="/img/edit-2.svg" alt="icon-permission"
                                                 style="transform: scale(0.9)">
                                        </v-btn>
                                    </div>

                                </template>
                            </DataTableCustom>
                        </div>
                    </div>
                    <div v-if="isLoading" class="display-flex align-center justify-center data-empty">
                        <v-progress-circular
                            :size="30"
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                        <div class="ml-8">
                            {{ $f.tc('loadingData') }}
                        </div>
                    </div>
                    <div class="list-table-pager">
                        <DataTableCustom
                            :headers="[]"
                            :items="[]"
                            :current-page="pagination.page"
                            :total-page="totalPage"
                            :items-per-page="pagination.rowsPerPage"
                            :total-items="totalItems"
                            @page-change="refresh"
                            @item-per-page-change="updatePerPage"
                        >
                        </DataTableCustom>
                    </div>
                </div>
            </v-container>
            <CampaignEditor ref="CampaignEditor" :on-saved="refresh"></CampaignEditor>
            <QCPermissionEditor ref="QCPermissionEditor"></QCPermissionEditor>
            <QCBatchCreator ref="QCBatchCreator"></QCBatchCreator>
            <QCBatchPermissionEditor ref="QCBatchPermissionEditor"></QCBatchPermissionEditor>
            <AddCallToBatchEditor ref="AddCallToBatchEditor"></AddCallToBatchEditor>
            <QCReassignEditor ref="QCReassignEditor"></QCReassignEditor>
        </div>
        <div class="px-10 py-10" v-else style="height: calc(100vh - 253px)">
            <LoadingBox :font-size="15" :size-loading="30"></LoadingBox>
        </div>
    </div>
</template>
<script>
import CampaignEditor from '@/views/Campaign/CampaignEditor'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import QCPermissionEditor from "@/views/QualityControl/Dialog/QCPermissionEditor";
import QcCampaignService from "@/services/qc.campaign.service";
import QCBatchCreator from "@/views/QualityControl/Dialog/QCBatchCreator";
import {mapState} from "vuex";
import DataTableCustom from "@/components/DataTableCustom";
import QCBatchPermissionEditor from "@/views/QualityControl/Dialog/QCBatchPermissionEdior";
import LoadingBox from "@/components/LoadingBox";
import AddCallToBatchEditor from "@/views/QualityControl/Dialog/AddCallToBatchEditor";
import QCReassignEditor from "@/views/QualityControl/Dialog/QCReassignEditor";

export default {
    name: 'QCBatchDetail',
    mixins: [RoleMixin],
    components: {
        QCReassignEditor,
        AddCallToBatchEditor,
        LoadingBox,
        QCBatchPermissionEditor,
        DataTableCustom,
        QCBatchCreator,
        QCPermissionEditor,
        CampaignEditor
    },
    data() {
        return {
            campaignList: [],
            permissionList: this.$const.QCCampaign.permissionList,
            filter: {
                callId: '',
                status: ''
            },
            items: [],
            pagination: {
                page: 1,
                rowsPerPage: 10
            },
            callListData: [],
            totalPage: 1,
            totalItems: 0,
            isLoading: false,
            isLoadingExport: false,
            sortDirection: 'asc',
            currentSort: '',
            sortBy: 'index',
            customerPropertyCondition: [],
            systemCondition: [],
            dataCollectionCondition: [],
        }
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
            batch: state => state.qccampaign.batch,
            permission: state => state.qccampaign.campaign.permission
        }),
        statusOptions() {
            return [
                {
                    text: this.$f.tc('todo'),
                    value: 'to_do'
                },
                {
                    text: this.$f.tc('inProgress'),
                    value: 'in_progress'
                },
                {
                    text: this.$f.tc('done'),
                    value: 'done'
                }
            ]
        }
    },
    mounted() {
        this.getBatch()
        this.refresh()
    },
    methods: {
        getBatch() {
            return QcCampaignService.CallListService.read(this.$route.params.QCCampaignId, this.$route.query.batchId).then(result => {
                this.$store.commit(this.$actionTypes.qccampaign.UPDATE_BATCH, result.data)
                let condition = result.data.condition_config.condition
                this.customerPropertyCondition = condition.filter(function (el) {
                    return el.source === "customer_property"
                })
                this.systemCondition = condition.filter(function (el) {
                    return el.source === "system"
                })
                this.dataCollectionCondition = condition.filter(function (el) {
                    return el.source === "data_collection"
                })
            }).catch(error => {
                if (error.response.status === 404) {
                    this.$router.push({
                        path: `/qc-campaign/${this.$route.params.QCCampaignId}/`,
                        query: {
                            tab: 'batch',
                        }
                    })
                }
            })
        },
        updateStatusBatch() {
            this.$appService.confirm(
                this.$f.tc(`${this.batch.status === 'open' ? 'close' : 'open'}BatchConfirm`, [this.batch.name])
            ).then(result => {
                if (result) {
                    QcCampaignService.CallListService.update(this.$route.params.QCCampaignId, this.$route.query.batchId, {
                        status: this.batch.status === 'open' ? 'close' : 'open'
                    }).then(result => {
                        this.$store.commit(this.$actionTypes.qccampaign.UPDATE_BATCH, result.data)
                        this.$appService.toastSuccess(this.$f.tc(`${this.batch.status}Batch`) + ' ' + this.$t('successful'))
                    })
                }
            })
        },
        refresh(pager) {
            this.callListData = []
            this.isLoading = true
            let qcCampaignId = this.$route.params.QCCampaignId
            let batchId = this.$route.query.batchId
            if (!batchId) {
                return
            }
            this.pagination.page = isNaN(pager) ? this.pagination.page : pager

            if (pager && pager.direction) {
                this.currentSort = pager.direction === 'desc' ? pager.value : '-' + pager.value
            }
            QcCampaignService.getCallsForBatch(
                qcCampaignId,
                batchId,
                {
                    page_size: this.pagination.rowsPerPage,
                    page: this.pagination.page,
                    ordering: this.currentSort,
                    search: this.filter.callId,
                    status: this.filter.status
                }
            ).then(
                result => {
                    this.callListData = []
                    this.totalItems = result.data.count || result.data.total
                    this.$store.commit(this.$actionTypes.qccampaign.SET_TOTAL_CALL, this.totalItems)
                    this.totalPage = Math.ceil(this.totalItems / this.pagination.rowsPerPage)
                    this.currentSort = result.data['ordering']
                    if (this.currentSort.indexOf('-') > -1) {
                        this.sortDirection = 'desc'
                    } else {
                        this.sortDirection = 'asc'
                    }
                    this.sortBy = result.data['ordering'].replace(/-/g, '')
                    result.data.headers.map(header => {
                        header.children = this.$utils.reFormatHeaderTable(header.children).map(header => {
                            header.class = 'nowrap'
                            return header
                        })
                        let dataArr = []
                        result.data.results.map(data => {
                            let dataItemCol = data[header.value]
                            dataItemCol["call_id"] = data["batch"]["call_id"]
                            dataArr.push(dataItemCol)
                        })
                        this.callListData.push({
                            title: header.text,
                            headers: header.children,
                            data: dataArr
                        })
                    })
                }
            ).finally(() => {
                this.isLoading = false
            })
        },
        updatePerPage(itemsPerPage) {
            this.pagination.rowsPerPage = itemsPerPage
            this.refresh()
        },
        exportBatch() {
            if (this.isLoadingExport) {
                return
            }
            this.isLoadingExport = true
            QcCampaignService.exportReportBatch(
                {id: this.$route.params.QCCampaignId},
                {id: this.$route.query.batchId}
            ).then(res => {
                this.$utils.saveFile(
                    res.data,
                    this.$filters.replaceSpecialCharacters(this.$utils.nonAccentVietnamese(this.batch.name + ' - QC Batch report')),
                    '.xlsx'
                )
            }).finally(() => {
                this.isLoadingExport = false
            })
        },
        openAssigneeEditor() {
            this.$appService.showLoading()
            Promise.all([
                this.loadUserPermissions(),
                this.getBatch()
            ]).then(result => {
                this.$appService.showLoading()
                this.$refs.QCBatchPermissionEditor.open(this.batch.assign_to, result[0].data).then(assignees => {
                    QcCampaignService.CallListService.update(this.$route.params.QCCampaignId, this.$route.query.batchId, {
                        assign_to: assignees
                    }).then(result => {
                        this.$store.commit(this.$actionTypes.qccampaign.UPDATE_BATCH, result.data)
                        this.$appService.hideLoading()
                    })
                })
            }).finally(this.$appService.hideLoading)
        },
        loadUserPermissions() {
            return QcCampaignService.UserPermissionService.search(this.$route.params.QCCampaignId)
        },
        backToBatchList() {
            this.$store.commit(this.$actionTypes.qccampaign.SET_INDEX_CALL, 0)
            this.$store.commit(this.$actionTypes.qccampaign.SET_TOTAL_CALL, 0)
            this.$router.push({
                path: `/qc-campaign/${this.$route.params.QCCampaignId}/`,
                query: {
                    tab: this.$route.query.tab
                }
            })
        },
        goToStartWork(item) {
            switch (item.status) {
                case 'in_progress':
                    if (item.qc_by === this.$store.state.user.profile.email) {
                        this.startWork(item)
                    } else {
                        this.$appService.toastError(this.$f.tc('canNotStartWork', [this.$f.tc('inProgress')]))
                    }
                    break
                case 'done':
                    if (RoleMixin.methods.canEditQCCampaign(this.qcCampaign.permission)) {
                        this.startWork(item)
                    } else {
                        this.$appService.toastError(this.$f.tc('canNotStartWork', [this.$f.tc('done')]))
                    }
                    break
                default:
                    this.startWork(item)
                    break
            }
        },
        startWork(item) {
            if (!item.index) {
                return
            }
            
            if (this.batch.status === 'close' && item.status === 'to_do') {
                this.$appService.toastInfo(this.$f.tc('batchHasClose'))
                return
            }
            
            this.$store.commit(this.$actionTypes.qccampaign.SET_INDEX_CALL, item.index)
            let data = {
                index: item.index,
                batchId: this.$route.query.batchId,
                batchStatus: this.batch.status,
                id: item.id
            }
            this.$emit('goToStartWork', data)
        },
        openAddCallEditor() {
            this.$refs.AddCallToBatchEditor.open().then(newCallId => {
                QcCampaignService.addCallToBatch(this.$route.params.QCCampaignId, this.$route.query.batchId, {
                    call_id: newCallId
                }).then(result => {
                    switch (result.data.code) {
                        case 0: //call exist in batch
                            this.$appService.toastInfo(result.data.message)
                            this.goToStartWork({'index': result.data.index, 'id': newCallId})
                            break
                        case 1://add call successfully
                            this.$appService.toastSuccess(result.data.message)
                            this.refresh()
                            break
                        case 2://call not exist in call logs
                            this.$appService.toastError(result.data.message)
                            break
                    }
                }).finally(() => {
                    this.$appService.hideLoading()
                })
            })
        },
        openReassignEditor(callId, currentAssignee) {
            if (this.batch.status === 'close') {
                this.$appService.toastInfo(this.$f.tc('batchHasClose'))
                return
            }
            
            this.$appService.showLoading()
            Promise.all([
                this.loadUserPermissions(),
                this.getBatch()
            ]).then(result => {
                this.$refs.QCReassignEditor.open(currentAssignee, result[0].data).then(newAssignee => {
                    QcCampaignService.updateCallStatus(this.$route.params.QCCampaignId, this.$route.query.batchId, callId, {
                        qc_by: newAssignee
                    }).then(() => {
                        this.$appService.toastSuccess(this.$f.tc('changeAssignee') + ' ' + newAssignee)
                        this.refresh()
                    })
                })
                this.$appService.hideLoading()
            })
        }
    },
    watch: {
        filter: {
            deep: true,
            handler: function () {
                this.pagination.page = 1
                this.refresh()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 10px 0 12px;
    flex-wrap: wrap;
    height: 72px;

    .icon-back {
        cursor: pointer;
    }
}

.tooltip-header {
    font-family: "open sans bold",serif;
}

.role-status {
    border-bottom: 1px solid #E4EDFA;
    padding: 7px;
    font-size: 14px;
    font-family: "open sans",serif;
}

.tab-title {
    color: #12274F;
    font-size: 20px;
    font-weight: 700;
    margin-right: 8px;
    height: 36px;
    line-height: 36px;
}

.status {
    font-size: 11px;
    text-transform: uppercase;
    color: #FFFFFF;
    font-family: "open sans bold",serif;
    height: 20px;
    line-height: 20px;
    padding: 0 5px;
    border-radius: 5px;
}

.status-open {
    background: #92c353;
}

.status-close {
    background: #c4314b;
}

.assignee {
    font-size: 14px;
    color: #8A97AA;
    display: flex;
    align-items: center;

    .btn-edit {
        cursor: pointer;
        width: 20px;
        height: 26px;
        margin-left: 8px;

        &:hover:after {
            content: url("/img/edit-2-blue.svg");
        }

        &:after {
            content: url("/img/edit-2.svg");
        }
    }
}

.call-list {
    padding: 10px !important;
    max-height: calc(100vh - 274px);
    overflow-y: auto;
    background: #FFFFFF;

    .icon-search {
        position: absolute;
        right: 10px;
        top: 10px;
    }

    .list-table {
        overflow-y: auto;
        border: 1px solid #DADFEC;
        border-bottom: none;
        align-items: stretch;

        .qc-campaign-table {
            &:first-child .data-table {
                border-width: 0 1px 1px 0;
            }

            &:nth-child(2) .data-table {
                border-width: 0 1px 1px 0;
            }

            &:last-child .data-table {
                border-width: 0 0 1px 0;
            }
        }
    }

    .data-empty {
        font-size: 14px;
        border: 1px solid #DADFEC;
        border-bottom: none;
        padding: 50px 0;
    }

    ::v-deep {
        .v-input__slot {
            border-radius: 0 !important;
        }

        .v-select__selection--comma {
            margin: 5px 4px 3px 0 !important;
        }

        .v-text-field .v-input__append-inner {
            margin-top: 3px !important;
        }
    }
}

::v-deep {
    .v-input__slot {
        background: #FFFFFF;
        padding: 0 10px !important;
        border-radius: 0 !important;
        border: 1px solid #DADFEC !important;
        font-size: 14px !important;
        height: 36px !important;

        input::placeholder {
            color: #8A97AA;
            padding-top: 2px;
        }
    }

    .v-input input {
        height: 36px;
    }

    .v-input__slot:after {
        border: none !important;
    }

    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .list-table-pager {
        .pager-wrap {
            border-top: none !important;
        }
    }
}
</style>
